import http from 'plugins/axios';

export default {

  getAllSupportCoin() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },


  //获取盒子列表
  getBoxList(data) {
    return http.get({
      url: `/admin/blindBox/listByPage`,
      data: data
    });
  },


  ////添加盒子
  createOrUpdateBox(data) {
    return http.post({
      url: `/admin/blindBox/addOrUpdate`,
      data: data
    });
  },

  // 查询盒子详情
  getBoxInfo(data) {
    return http.get({
      url: `/admin/blindBox/info`,
      data: data
    });
  },

  ////删除盒子
  deleteBox(data) {
    return http.post({
      url: `/admin/blindBox/logic/delete`,
      data: {
        id:data
      },
      dataType:'form'
    });
  },
  // 上下架盒子
  updateStatus(data) {
    return http.post({
      url: `/admin/blindBox/state`,
      data: data,
      dataType:'form'
    });
  },
  // 统计NFT等级的个数
  getNftLevelNum() {
    return http.get({
      url: `/admin/blindBoxCoin/statisticsByGradeCount`
    });
  },
  // 获取白名单
  getWhiteList(data) {
    return http.get({
      url: '/admin/blindBox/whiteList',
      data
    })
  },
  // 添加白名单
  addWhiteList(data) {
    return http.post({
      url: '/admin/blindBox/whiteList/addUser',
      data,
      dataType:'form'
    })
  },
  // 设置支付方式
  setPay(data) {
    return http.post({
      url: '/admin/blindBox/whiteList/updateUserPayInfo',
      data,
      dataType:'form'
    })
  },
  // 删除白名单
  delWhiteList(data) {
    return http.post({
      url: '/admin/blindBox/whiteList/deleteUser',
      data,
      dataType:'form'
    })
  },
  // 为某个白名单分配盒子
  addBox(data) {
    return http.post({
      url: '/admin/blindBox/whiteList/updateUserDistributionNum',
      data,
      dataType:'form'
    })
  }

};
